import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  // mode: 'history',
  mode: 'hash',
  linkActiveClass: 'myactive',
  routes: [
    {
      path: '/',
      name: '',
      component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome1/index'),
      children: [
        {
          path: '/', // 首页
          name: 'firstpage',
          component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome1/components/firstpage')
        },
        {
          path: '/home/biddingNotice', // 招标公告
          name: 'biddingNotice',
          component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome1/components/biddingNotice')
        },
        {
          path: '/home/nobiddingNoticeMore', // 非招标公告
          name: 'nobiddingNoticeMore',
          component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome1/components/nobiddingNoticeMore')
        },
        {
          path: '/home/bidWinPublic', // 中标公告
          name: 'bidWinPublic',
          component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome1/components/bidWinPublic')
        },
        {
          path: '/home/serviceCenter', // 服务中心
          name: 'serviceCenter',
          component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome1/components/serviceCenter')
        },
        {
          path: '/home/noticeSearch', // 公告搜索
          name: 'noticeSearch',
          component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome1/noticeSearch')
        },
        {
          path: '/home/noticeTitleMore', // 通知公告更多
          name: 'noticeTitleMore',
          component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome1/components/noticeTitleList')
        },
        {
          path: '/home/noticeText', // 通知公告正文
          name: 'noticeText',
          component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome1/components/noticeText')
        },
        {
          path: '/home/NoticeShow', // 通知公告正文
          name: 'NoticeShow',
          component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome1/NoticeShow')
        }
      ]
    },
    // {
    //   path: '/',
    //   name: '',
    //   component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome/index'),
    //   children: [
    //     {
    //       path: '/', // 首页
    //       name: 'firstpage',
    //       component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome/components/firstpage')
    //     },
    //     {
    //       path: '/biddingNotice', // 招标公告
    //       name: 'biddingNotice',
    //       component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome/components/biddingNotice')
    //     },
    //     {
    //       path: '/nobiddingNoticeMore', // 非招标公告
    //       name: 'nobiddingNoticeMore',
    //       component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome/components/nobiddingNoticeMore')
    //     },
    //     {
    //       path: '/bidWinPublic', // 中标公告
    //       name: 'bidWinPublic',
    //       component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome/components/bidWinPublic')
    //     },
    //     {
    //       path: '/serviceCenter', // 服务中心
    //       name: 'serviceCenter',
    //       component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome/components/serviceCenter')
    //     },
    //     {
    //       path: '/noticeSearch', // 公告搜索
    //       name: 'noticeSearch',
    //       component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome/noticeSearch')
    //     },
    //     {
    //       path: '/noticeTitleMore', // 通知公告更多
    //       name: 'noticeTitleMore',
    //       component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome/components/noticeTitleList')
    //     },
    //     {
    //       path: '/noticeText', // 通知公告正文
    //       name: 'noticeText',
    //       component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome/components/noticeText')
    //     },
    //     {
    //       path: '/NoticeShow', // 通知公告正文
    //       name: 'NoticeShow',
    //       component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome/NoticeShow')
    //     }
    //   ]
    // },
    {
      path: '/newhome1/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome1/Login')
    },
    {
      path: '/home/NoticeShowDetail', // 通知公告正文
      name: 'NoticeShowDetail',
      component: () => import(/* webpackChunkName: "home" */ '@/pages/newhome1/NoticeShow/detail')
    }
  ]

})



// WEBPACK FOOTER //
// ./src/router/index.js